var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',{staticClass:"app-layout"},[_c('nav',{staticClass:"navbar navbar-default navbar-fixed-top"},[_c('div',{staticClass:"container-fluid"},[_vm._t("header")],2)]),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }